import useMutationGameCreateUpdate from "./game-use-mutation-create-update";
import useMutationGameDelete from "./game-use-mutation-delete";
import useMutationGameOrder from "./game-use-mutation-order";

export const gameUseMutation = {
  createUpdate: useMutationGameCreateUpdate,
  delete: useMutationGameDelete,
  order: useMutationGameOrder,
};
